import { types } from "../types/typesUi";
const initialState = {
  collapsedSidebar: false,
  visibleForm: false,
  visibleDrawer: false,
  visibleModal: false,
  settingsLayout: {
    style_menu: true,
    mode_menu: true,
  },
  loading: false,
  mytheme: "light",
};
export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.uiCollapsedSidebar:
      return {
        ...state,
        collapsedSidebar: action.payload,
      };
    case types.uiShowForm:
      return {
        ...state,
        visibleForm: action.payload,
      };
    case types.uiShowDrawer:
      return {
        ...state,
        visibleDrawer: action.payload,
      };
    case types.uiShowModal:
      return {
        ...state,
        visibleModal: action.payload,
      };
    case types.uiLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case types.uiSetSettingsLayout:
      return {
        ...state,
        settingsLayout: action.payload,
      };
    case types.uiSetToggleTheme:
      return {
        ...state,
        mytheme: state.mytheme === "light" ? "dark" : "light",
      };
    default:
      return state;
  }
};
